import { useEffect, useState } from 'react'
import { OrderDelivery } from '../model'
import { getOrderDeliveries } from '../services/api/deliveries'

export const useDeliveries = () => {
    const [deliveryList, setDeliveryList] = useState<OrderDelivery[]>([])
    const [loading, setIsLoading] = useState(true)

    useEffect(() => {
        if (!deliveryList.length) {
            getDeliveries(10)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getDeliveries = async (size: number = 10) => {
        setIsLoading(true)
        try {
            const res = await getOrderDeliveries({ page: 1, pageSize: size })
            setDeliveryList(res.items)
        } finally {
            setIsLoading(false)
        }
    }

    return { deliveryList, getDeliveries, loading }
}
